import { render, staticRenderFns } from "./ChallengesNotes.vue?vue&type=template&id=2c734480&"
import script from "./ChallengesNotes.vue?vue&type=script&lang=js&"
export * from "./ChallengesNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports